import type { ListItemData } from "@ms/shared-components/components/GenericPanelList";
import { RoleNode } from "../config/types";

export const transformRoleData = (roleData: any[]): ListItemData[] => {
  return roleData.map((role) => {
    const id = role.id;

    let permissionCount = 0;
    if (Array.isArray(role.permissions)) {
      permissionCount = role.permissions.length;
    } else if (role.permissionCount !== undefined) {
      permissionCount = role.permissionCount;
    } else if (typeof role.permissions === "number") {
      permissionCount = role.permissions;
    }

    return {
      id,
      leftContent: role.name || "未命名角色",
      rightContent: permissionCount.toString(), // 总是显示数字，即使为0
      roleData: {
        id,
        name: role.name || "未命名",
        code: role.code || "",
        parentId: role.parentId,
      },
    };
  });
};

export const createRoleNode = (item: ListItemData): RoleNode => {
  const roleData = item.roleData;

  return {
    id: item.id,
    name: roleData.name || "未命名",
    code: roleData.code || "",
    parentId: roleData.parentId,
  };
};
